import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { initErrorReporting } from './error-reporting.js';
import './i18n.js';
import { applyUiSettings } from './state/settings.js';
import './styles.css';

initErrorReporting();
applyUiSettings();

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
